export const facilitySectionResize = () => {
	const windowWidth = window.innerWidth
	const facilityImgs = $('.facility-img')
	const facilitySection = $('.section--facility-item')
	const facilityBlocks = $('.facility-block')
	const facilityContainerWidth = $('.facility-container').width()
	const facilityContainerOuterWidth = windowWidth - $('.facility-container').width()

	const overlapPaddingWidth = facilityImgs.width() - 80 + 56
	const halfContainerPaddingWidth = facilityContainerOuterWidth / 2

	if (windowWidth < 576) {
		facilityBlocks.each((idx, block) => {
			const imgHeight = facilityImgs[idx].clientHeight
			$(block).css('padding', `${imgHeight - 56 + 16}px 16px 16px`)
			$(block).css('width', '100%')
			$(facilityImgs[idx]).css('transform', `translateX(0)`)
			$(facilityImgs[idx]).css('margin-bottom', '24px')
			if (block.classList.contains('left')) {
				$(block).css('transform', 'initial')
				$(facilityImgs[idx]).css('transform', 'translateX(16px)')
			}
		})
	} else if (windowWidth < 768) {
		facilityBlocks.each((idx, block) => {
			const imgHeight = facilityImgs[idx].clientHeight
			$(facilitySection[idx]).css('margin-bottom', '24px')
			$(block).css('width', 'calc(100% - 80px)')
			if (block.classList.contains('left')) {
				$(block).css('padding', `${imgHeight - 160 + 16}px 80px 16px`)
				$(block).css('right', `${halfContainerPaddingWidth}px`)
				$(facilityImgs[idx]).css('transform', `translateX(0)`)
			} else {
				$(block).css('padding', `${imgHeight - 160 + 16}px 80px 16px`)
			}
		})
	} else if (windowWidth < 900) {
		facilityBlocks.each((idx, block) => {
			$(block).css('width', 'calc(100% - 80px)')
			$(facilityImgs[idx]).css('transform', `translateX(0)`)
			if (block.classList.contains('left')) {
				$(block).css('transform', `translateX(0)`)
				$(block).css('right', '80px')
				$(block).css('padding', `0 ${overlapPaddingWidth}px 0 32px`)
			} else {
				$(block).css('padding', `0 ${halfContainerPaddingWidth}px 0 ${overlapPaddingWidth - 32}px`)
			}
			const blockHeight = block.clientHeight
			const imgHeight = facilityImgs[idx].clientHeight
			$(facilitySection[idx]).css('margin-bottom', `${blockHeight + 80 - imgHeight + 56}px`)
		})
	} else {
		facilityBlocks.each((idx, block) => {
			$(block).css('width', `${facilityContainerWidth + halfContainerPaddingWidth - 80}px`)
			$(facilityImgs[idx]).css('transform', `translateX(0)`)
			if (block.classList.contains('left')) {
				$(block).css('right', '80px')
				$(facilityImgs[idx]).css('transform', `translateX(0)`)
				$(block).css('padding', `0 ${overlapPaddingWidth}px 0 ${halfContainerPaddingWidth}px`)
			} else {
				$(block).css('padding', `0 ${halfContainerPaddingWidth}px 0 ${overlapPaddingWidth}px`)
			}
			const blockHeight = block.clientHeight
			const imgHeight = facilityImgs[idx].clientHeight
			$(facilitySection[idx]).css('margin-bottom', `${blockHeight + 80 - imgHeight + 56}px`)
		})
	}
}
// 	if (windowWidth < 576) {
// 		facilityBlocks.each((idx, block) => {
// 			const imgHeight = facilityImgs[idx].clientHeight;
// 			block.style.padding = `${imgHeight - 56 + 16}px 16px 16px`;
// 			block.style.width = "100%";
// 			facilityImgs[idx].style.transform = `translateX(0)`;
// 			facilitySection[idx].style.marginBottom = "24px";

// 			if (block.classList.contains("left")) {
// 				block.style.transform = "initial";
// 				facilityImgs[idx].style.transform = "translateX(16px)";
// 			}
// 		});
// 	} else if (windowWidth < 768) {
// 		facilityBlocks.each((idx, block) => {
// 			const imgHeight = facilityImgs[idx].clientHeight;
// 			facilitySection[idx].style.marginBottom = "24px";

// 			block.style.width = `calc(100% - 80px)`;
// 			if (block.classList.contains("left")) {
// 				block.style.padding = `${imgHeight - 160 + 16}px 80px 16px`;
// 				block.style.right = `${halfContainerPaddingWidth}px`;
// 				facilityImgs[idx].style.transform = `translateX(0)`;
// 			} else {
// 				block.style.padding = `${imgHeight - 160 + 16}px 80px 16px`;
// 			}
// 		});
// 	} else if (windowWidth < 900) {

// 		facilityBlocks.each((idx, block) => {
// 			block.style.width = `calc(100% - 80px)`;
// 			facilityImgs[idx].style.transform = `translateX(0)`;
// 			if (block.classList.contains("left")) {
// 				block.style.transform = `translateX(0)`;
// 				block.style.right = "80px";

// 				block.style.padding = `0 ${overlapPaddingWidth}px 0 32px`;
// 			} else {
// 				block.style.padding = `0 ${halfContainerPaddingWidth}px 0 ${overlapPaddingWidth - 32}px`;
// 			}

// 			const blockHeight = block.clientHeight;
// 			const imgHeight = facilityImgs[idx].clientHeight;
// 			facilitySection[idx].style.marginBottom = `${blockHeight + 80 - imgHeight + 56}px`;
// 		});
// 	} else {
// 		facilityBlocks.each((idx, block) => {
// 			block.style.width = `${facilityContainerWidth + halfContainerPaddingWidth - 80}px`;
// 			facilityImgs[idx].style.transform = `translateX(0)`;
// 			if (block.classList.contains("left")) {
// 				block.style.right = "80px";

// 				block.style.transform = `translateX(0)`;
// 				block.style.padding = `0 ${overlapPaddingWidth}px 0 ${halfContainerPaddingWidth}px`;
// 			} else {
// 				block.style.padding = `0 ${halfContainerPaddingWidth}px 0 ${overlapPaddingWidth}px`;
// 			}
// 			const blockHeight = block.clientHeight;
// 			const imgHeight = facilityImgs[idx].clientHeight;
// 			facilitySection[idx].style.marginBottom = `${blockHeight + 80 - imgHeight + 56}px`;
// 		});
// 	}
// };

export const facilityFadeIn = (windowObject) => {
	const scrollTop = windowObject.scrollTop()
	const facilityBlocks = $('.facility-block')
	const windowHeight = windowObject.height()

	facilityBlocks.each(function () {
		if ($(this).offset().top - windowHeight / 2 <= scrollTop) {
			this.classList.add('in')
		}
	})
}
